goog.provide("shadow.js.shim.module$src$svg$files_folders$file_text_svg$default");
shadow.js.shim.module$src$svg$files_folders$file_text_svg$default = shadow.js.shim.module$src$svg$files_folders$file_text_svg.default;
